export default __webpack_public_path__ + "static/media/Animale_mob_banner_2.0db6685f.png";